export enum StudyName {
  ComputerScience = 'SHARED.STUDIES.FIELDS.COMPUTER-SCIENCE',
  NewMediaArts = 'SHARED.STUDIES.FIELDS.NEW-MEDIA-ARTS',
  GraphicDesign = 'SHARED.STUDIES.FIELDS.GRAPHIC-DESIGN',
  InteriorDesign = 'SHARED.STUDIES.FIELDS.INTERIOR-DESIGN',
  InformationManagement = 'SHARED.STUDIES.FIELDS.INFORMATION-MANAGEMENT',
  CultureOfJapan = 'SHARED.STUDIES.FIELDS.JAPAN-CULTURE',
  Other = 'SHARED.STUDIES.FIELDS.OTHER',
  Postgraduate = 'SHARED.STUDIES.TYPES.POSTGRADUATE',
  MBA = 'MBA'
}

export enum ModeName {
  FullTime = 'SHARED.STUDIES.MODES.FULL-TIME',
  PartTime = 'SHARED.STUDIES.MODES.PART-TIME',
  Internet = 'SHARED.STUDIES.MODES.INTERNET.FORMAL'
}

export enum TypeName {
  Engineer = 'SHARED.STUDIES.TYPES.ENGINEER',
  Bachelor = 'SHARED.STUDIES.TYPES.BACHELOR',
  UniformMasters = 'SHARED.STUDIES.TYPES.UNIFORM-MASTERS',
  Graduate = 'SHARED.STUDIES.TYPES.GRADUATE',
  Postgraduate = 'SHARED.STUDIES.TYPES.POSTGRADUATE',
  PhD = 'SHARED.STUDIES.TYPES.PHD'
}

export enum DegreeName {
  First = 'INITIAL-WIZARD.STEP-1.STUDIES.DEGREES.FIRST',
  Second = 'INITIAL-WIZARD.STEP-1.STUDIES.DEGREES.SECOND',
  Third = 'INITIAL-WIZARD.STEP-1.STUDIES.DEGREES.THIRD',
  Postgraduate = 'SHARED.STUDIES.TYPES.POSTGRADUATE'
}

export enum LanguageName {
  Polish = 'SHARED.LANGUAGES.POLISH.IN-POLISH',
  English = 'SHARED.LANGUAGES.ENGLISH.IN-ENGLISH'
}

export enum LocalizationName {
  Warsaw = 'SHARED.LOCALIZATIONS.WARSAW',
  Gdansk = 'SHARED.LOCALIZATIONS.GDANSK',
  Bytom = 'SHARED.LOCALIZATIONS.BYTOM'
}

export enum OtherNames {
  Courses = 'SHARED.STUDIES.OTHER.COURSES',
  AnimaTricks = 'AnimaTrics',
  MBA = 'MBA'
}
